import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, EMPTY_ARRAY, SelectInput } from 'commons-ui';
import { onChangeConfigValAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	weeklyCashbackLimit: yup.string().required('Weekly Limit is required'),
	overallCashbackLimit: yup.string().required('Overall Limit is required')
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	weeklyCashbackLimit: yup.string().required('Weekly Limit is required'),
	overallCashbackLimit: yup.string().required('Overall Limit is required')
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	WEEKLY_LIMIT: 'weeklyCashbackLimit',
	OVERALL_LIMIT: 'overallCashbackLimit'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.WEEKLY_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.OVERALL_LIMIT)])
	])
];

export const EDIT_TDS_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.WEEKLY_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.OVERALL_LIMIT)])
	])
];

const sampleData: { [key: string]: string } = { id: '1', label: 'TEST' };

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [sampleData],
			required: true
		})
		.setToolTip('TDS Segment Name'),
	[FORM_FIELD_KEYS.WEEKLY_LIMIT]: new RenderConfig()
		.setName('weeklyCashbackLimit')
		.setLabel('Weekly Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Tds Config Weekly Limit'),
	[FORM_FIELD_KEYS.OVERALL_LIMIT]: new RenderConfig()
		.setName('overallCashbackLimit')
		.setLabel('Overall Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Tds Config Overall Limit')
};

export const getFormDefaults = (segmentName: string, weeklyCashbackLimit: number, overallCashbackLimit: number) => {
	return {
		segmentName,
		weeklyCashbackLimit,
		overallCashbackLimit
	};
};
